import script from "./MisTorneosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MisTorneosView.vue?vue&type=script&setup=true&lang=ts"

import "./MisTorneosView.vue?vue&type=style&index=0&id=9f293e02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f293e02"]])

export default __exports__